import React from "react";
import { PenLine, Mail } from "lucide-react";

const WritingsSection = () => {
  return (
    <section id="writings" className="py-16 md:py-24" style={{ background: "#0C0C0E" }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        {/* Section header */}
        <div className="mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#06B6D4] mb-3">Thoughts</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">Writings</h2>
          <p className="mt-3 max-w-lg text-sm leading-relaxed" style={{ color: "#6B6B7A" }}>
            Essays on product, growth, and the mechanics of building at scale. Ex-Chief Editor, Vox Populi — IIT Kanpur.
          </p>
        </div>

        {/* Coming soon card */}
        <div
          className="flex flex-col sm:flex-row items-start sm:items-center gap-6 p-7 rounded-2xl border"
          style={{ background: "#0F0F12", border: "1px solid #1C1C22" }}
        >
          {/* Icon */}
          <div
            className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: "rgba(6,182,212,0.08)", border: "1px solid rgba(6,182,212,0.18)" }}
          >
            <PenLine className="w-6 h-6 text-[#06B6D4]" />
          </div>

          {/* Text + CTA */}
          <div className="flex-1 min-w-0">
            <p className="text-white font-semibold text-base mb-1">Essays coming up soon</p>
            <p className="text-sm leading-relaxed mb-4" style={{ color: "#6B6B7A" }}>
              Writing on product strategy, growth mechanics, and building at scale. Drop your email to get notified when the first one is out.
            </p>
            <a
              href="mailto:adisonth98@gmail.com?subject=Subscribe to Aditya's writings"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200"
              style={{ background: "rgba(6,182,212,0.1)", color: "#06B6D4", border: "1px solid rgba(6,182,212,0.25)" }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(6,182,212,0.18)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "rgba(6,182,212,0.1)"; }}
            >
              <Mail className="w-4 h-4" />
              Stay updated
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WritingsSection;

